"use strict";
/* eslint max-len: ["error", 200] */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var route_settings_1 = require("@reverbdotcom/commons/dist/route_settings");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var marketplace_1 = require("./routes/marketplace");
var landing_page_1 = require("./routes/landing_page");
var curated_search_1 = require("./routes/curated_search");
var brand_1 = require("./routes/brand");
var csp_index_1 = require("./routes/csp_index");
var sale_1 = require("./routes/sale");
var item_show_1 = require("./routes/item_show");
var handpicked_1 = require("./routes/handpicked");
var collection_1 = require("./routes/collection");
var ended_watched_products_1 = require("./routes/ended_watched_products");
var recently_viewed_1 = require("./routes/recently_viewed");
var watched_products_1 = require("./routes/watched_products");
var feed_customization_1 = require("./routes/feed_customization");
var my_auctions_1 = require("./routes/my_auctions");
var homepage_1 = require("./routes/homepage");
var progressive_onboarding_1 = require("./routes/progressive_onboarding");
var convert_shop_type_1 = require("./routes/convert_shop_type");
var cms_route_1 = require("./routes/cms_route");
var identity_verification_1 = require("./routes/identity_verification");
var holiday_sale_1 = require("./routes/holiday_sale");
var shop_1 = require("./routes/shop");
var url_helpers_1 = require("./components/shared/url_helpers");
var checkout_1 = require("./routes/checkout");
var track_article_page_view_1 = require("@reverbdotcom/commons/dist/components/track_article_page_view");
/*
 * All routes for the ReverbRouter are defined here. These are exported
 * separately so they can be shared between the client and server side
 * Router.
 *
 * Note: All routes here are defined with a relative route to support international
 * prefix routing, which is defined below in the actual export
 *
 * Please add a key to allow React to do some fancy DOM diffing (and to prevent an error in console)
 */
var Routes = [
    React.createElement(route_settings_1.Route, { key: "feed", path: "my/feed", props: {
            clientSide: true,
            pageViewEvent: {
                pageName: mparticle_tracker_1.MParticlePageName.Feed,
            },
        }, getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./feed/feed_grid').default);
            }, 'feed');
        } }),
    React.createElement(route_settings_1.Route, { key: "sell", path: "sell", props: {
            pageViewEvent: {
                pageName: mparticle_tracker_1.MParticlePageName.SellForm,
            },
        } }),
    React.createElement(route_settings_1.Route, { key: "sell/search", path: "sell/search", props: {
            clientSide: true,
            pageViewEvent: {
                pageName: mparticle_tracker_1.MParticlePageName.SellSearch,
            },
        }, getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/sell/sell_search').default);
            }, 'sell');
        } }),
    React.createElement(route_settings_1.Route, { key: "sell_prefilled", path: "sell_prefilled", props: {
            pageViewEvent: function (_a) {
                var location = _a.location;
                return ({
                    pageName: mparticle_tracker_1.MParticlePageName.SellForm,
                    cspId: location.query.seed_id,
                });
            },
        } }),
    React.createElement(route_settings_1.Route, { key: "item/:slug/similar", path: "item/:slug/similar", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/discovery/similar_listings_grid').default);
            }, 'similar-listings');
        } }),
    React.createElement(route_settings_1.Route, { key: "my/selling/shipping_labels/new/:orderId", path: "my/selling/shipping_labels/new/:orderId", getComponent: function (_, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/discovery/shipping_labels/shipping_labels_form_container')
                    .default);
            }, 'shipping-labels');
        } }),
    React.createElement(route_settings_1.Route, { key: "my/selling/shipping_labels/:shipmentId", path: "my/selling/shipping_labels/:shipmentId", getComponent: function (_, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/discovery/shipping_labels/shipping_rates_form')
                    .default);
            }, 'shipping-labels');
        } }),
    React.createElement(route_settings_1.Route, { key: "my/selling/shipping_labels/:shipmentId/edit", path: "my/selling/shipping_labels/:shipmentId/edit", getComponent: function (_, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/discovery/shipping_labels/edit_shipment_container')
                    .default);
            }, 'shipping-labels');
        } }),
    React.createElement(route_settings_1.Route, { key: "price-guide", 
        // The route for this page matches both the search route
        // and the show route. The show route is not rendered
        // by React. As a result `clientSide` has to be set to
        // false until the show route can be distinguished from
        // the search route.
        props: { clientSide: false }, path: url_helpers_1.PRICE_GUIDE_ROUTE, getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/price_guides/price_guide_page').default);
            }, 'price-guide');
        } }),
    React.createElement(route_settings_1.Route, { key: "p/:slug/", props: {
            clientSide: true,
        }, path: "p/:slug(/:condition)", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/csp2_layout').default);
            }, 'csp2');
        } }),
    React.createElement(route_settings_1.Route, { key: "brand-manager", props: { clientSide: true }, path: "brand-manager", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/brand-manager/pages/index').default);
            }, 'brand_manager');
        } }),
    React.createElement(route_settings_1.Route, { key: "brand-manager/:brand_slug", path: "brand-manager/:brand_slug", props: { clientSide: true }, getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/brand-manager/pages/csps/index').default);
            }, 'brand_manager');
        } }),
    React.createElement(route_settings_1.Route, { key: "brand-manager/:brand_slug/:csp_slug", props: { clientSide: true }, path: "brand-manager/:brand_slug/:csp_slug", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('./components/brand-manager/pages/csps/show').default);
            }, 'brand_manager');
        } }),
    React.createElement(route_settings_1.Route, { key: "page/:slug", path: "page/:slug", props: {
            pageViewEvent: function (_a) {
                var params = _a.params;
                return ({
                    pageName: mparticle_tracker_1.MParticlePageName.Page,
                    pageSlug: params.slug,
                });
            },
        } }),
    React.createElement(route_settings_1.Route, { key: "news/:slug", path: "news/:slug", getComponent: function (_location, cb) {
            cb(null, track_article_page_view_1.default);
        } }),
];
Routes.push.apply(Routes, tslib_1.__spreadArrays([shop_1.ShopRoutes,
    csp_index_1.default,
    homepage_1.default,
    my_auctions_1.default,
    sale_1.default,
    item_show_1.ItemShowRoute,
    item_show_1.Item2ShowRoute,
    item_show_1.ItemPreviewRoute,
    item_show_1.ItemPreviewConfirmRoute,
    handpicked_1.default,
    brand_1.BrandRoute,
    collection_1.default], marketplace_1.default, [landing_page_1.default,
    curated_search_1.default,
    ended_watched_products_1.default,
    feed_customization_1.default,
    recently_viewed_1.default,
    watched_products_1.default,
    holiday_sale_1.default,
    convert_shop_type_1.default,
    identity_verification_1.CoreIdentityVerificationRoute,
    identity_verification_1.LPIdentityVerificationRoute,
    cms_route_1.CmsCategoryRootRoute,
    cms_route_1.CmsCategoryLeafRoute], checkout_1.default));
Routes.push.apply(Routes, progressive_onboarding_1.default);
exports.default = Routes;
//# sourceMappingURL=discovery-routes.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/discovery-routes.js
// module id = YJUW
// module chunks = 20 21